import ContactInformation from './ContactInformation';
import ShippingAddress from './ShippingAddress';
import AccountPassword from './AccountPassword';
import EmailPreferences from './EmailPreferences';
import Username from '../Username';

const Account = () => {
	return (
		<div id="account_dashboard">
			<div className="account-dashboard">
				<div className="acc-info-dashboard">
					<div className="acc-main-content">
						<Username />

						<ContactInformation />

						<ShippingAddress />

						<AccountPassword />

						<EmailPreferences />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Account;
